import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG, WS_ENDPOINT_URL } from "./configs/AppConfig";
import "./lang";
import { enablePushForAdmin } from "utils/pushFunction";
import PushNavListener from "PushNavListener";
import AdminWsListener from "AdminWsListener";
import { AdminNotificationsProvider } from "contexts/AdminNotificationsContext";
import { PermissionProvider } from "contexts/PermissionContext";
import { API_BASE_URL } from "constants/ApiConstant";
// import AdminWsBridge from "AdminWsBridge";
// import { DataProvider } from "contexts/DataProvider";
// import { WebSocketProvider } from "contexts/WebSocketProvider";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  useEffect(() => {
    // ✅ Auto-enable push for non-iOS devices (iOS requires user gesture)
    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const maxTouch = navigator.maxTouchPoints || 0;
    
    // Detect iOS/iPadOS (which require user gesture for notifications)
    const isiOS = /iPad|iPhone|iPod/.test(ua);
    const isiPadOS = platform === "MacIntel" && maxTouch > 1; // iPadOS 13+ reports as Mac
    const needsUserGesture = isiOS || isiPadOS;
    
    if (!needsUserGesture) {
      // Small delay to ensure user is authenticated
      const timer = setTimeout(() => {
        enablePushForAdmin().catch(err => {
          // Don't log error if user just hasn't granted permission yet
          if (Notification?.permission !== 'denied') {
            console.log('[App] Push auto-enable skipped or failed:', err?.message || err);
          }
        });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);


  // useEffect(() => {
  //   const preventZoom = (event) => {
  //     if (event.ctrlKey || event.touches?.length > 1) {
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener("wheel", preventZoom, { passive: false });
  //   document.addEventListener("keydown", (event) => {
  //     if (event.ctrlKey && (event.key === "+" || event.key === "-")) {
  //       event.preventDefault();
  //     }
  //   });
  //   document.addEventListener("touchmove", preventZoom, { passive: false });

  //   return () => {
  //     document.removeEventListener("wheel", preventZoom);
  //     document.removeEventListener("keydown", preventZoom);
  //     document.removeEventListener("touchmove", preventZoom);
  //   };
  // }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <PermissionProvider>
            <AdminNotificationsProvider>
              {/* ✅ NOW it can read context */}
              <AdminWsListener />

              <PushNavListener />
              <ThemeSwitcherProvider
                themeMap={themes}
                defaultTheme={THEME_CONFIG.currentTheme}
                insertionPoint="styles-insertion-point"
              >
                <Layouts />
              </ThemeSwitcherProvider>
            </AdminNotificationsProvider>
          </PermissionProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
